/* eslint-disable @typescript-eslint/ban-ts-comment */
import Axios, { AxiosResponse, InternalAxiosRequestConfig } from 'axios'
import { getAuth, getIdToken } from 'firebase/auth'

import { API_BASE_URL } from '@apps-common/config'

export const axios = Axios.create({
  // baseURL: process.env.REACT_APP_API_BASE_URL || API_BASE_URL
  baseURL: API_BASE_URL,
  timeout: 45000,
  headers: {
    'ngrok-skip-browser-warning': 'true'
  }
})

export const minRequestDelay = async (timeout?: number) => {
  await new Promise((resolve) => {
    setTimeout(resolve, timeout || 250)
  })
}

axios.interceptors.request.use(
  async (config: InternalAxiosRequestConfig) => {
    const user = getAuth().currentUser

    if (user) {
      const token = await getIdToken(user)

      // console.log('TOKEN', token)
      // @ts-ignore
      // config.headers['Content-Type'] = 'application/json'
      config.headers.Authorization = `Bearer ${token}`
    }

    // @ts-ignore
    config.headers.accept = 'application/json'

    await minRequestDelay()

    return config
  },
  (error) => error
)

axios.interceptors.response.use(
  (response: AxiosResponse) => {
    if (response?.data?.result === 'Failed') {
      throw new Error(response?.data?.msg || 'Failed to load data')
    }

    return response
  },
  (error) => {
    if (error?.response?.data?.msg) {
      throw new Error(error?.response?.data?.msg)
    }

    throw error
  }
)
